<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <div class="content">
            <div class="container-fluid pt-5">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-md-8">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.reduction_types')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="reduction_types.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th>{{$t('form.setting.sortOrder')}}</th>
                                            <th>{{$t('form.setting.active')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(type, index) in reduction_types" :key="index">
                                            <td>{{type.name}}</td>
                                            <td>{{type.sort_order}}</td>
                                            <td>
                                                <b-badge variant="success" v-if="type.active">{{$t('form.setting.yes')}}</b-badge>
                                                <b-badge variant="danger" v-else>{{$t('form.setting.no')}}</b-badge>
                                            </td>
                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsReductiontypes"
                                                    class="btn btn-info btn-sm" @click="edit(index)">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsReductiontypes"
                                                    class="btn btn-danger btn-sm" @click="remove(type)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                                @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="card" v-if="toggleForm">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.reductionTypesCreate')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <div class="form-group">
                                    <label>{{$t('form.setting.sortOrder')}}</label>
                                    <input type="number" class="form-control" v-model="sort_order">
                                </div>
                                <div class="form-group">
                                    <b-form-checkbox v-model="active">
                                        {{$t('form.setting.active')}}
                                    </b-form-checkbox>
                                </div>

                                <b-button variant="primary" @click="submit">{{$t('button.save')}}</b-button>
                            </div>
                        </div>

                        <div class="card" v-else>
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.reductionTypesEdit')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <div class="form-group">
                                    <label>{{$t('form.setting.sortOrder')}}</label>
                                    <input type="number" class="form-control" v-model="sort_order">
                                </div>
                                <div class="form-group">
                                    <b-form-checkbox v-model="active">
                                        {{$t('form.setting.active')}}
                                    </b-form-checkbox>
                                </div>

                                <b-button variant="primary" @click="update">{{$t('button.update')}}</b-button>
                                <b-button variant="outline-primary" @click="cancel">{{$t('button.cancel')}}</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                toggleForm: true,

                pagination: {
                    current_page: 1
                },

                name: '',
                id: '',
                sort_order: null,
                active: false,

                reduction_types: [],
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsReductiontypes) {
                return this.$router.push('/');
            }

            this.getReductionTypes();
        },

        methods: {
            getReductionTypes() {
                this.isLoading = true;

                axios
                    .get('/api/reduction-types?page=' + this.pagination.current_page)
                    .then(response => {
                        this.reduction_types = response.data.data.data;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getReductionTypes();
            },

            submit() {
                if(!this.permissions.createSettingsReductiontypes){
                    this.showAlert(this.$t('form.validation.cantCreateReductionTypePermission'),'danger');
                    return;
                }
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .post('/api/reduction-types', {
                        name: this.name,
                        sort_order: this.sort_order,
                        active: this.active
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.name = '';
                            this.sort_order = null;
                            this.active = false;
                            this.showAlert(response.data.message);
                            this.reduction_types.unshift(response.data.data);
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {

                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            edit(index) {
                 if(!this.permissions.editSettingsReductiontypes){
                    this.showAlert(this.$t('form.validation.cantEditReductionTypePermission'),'danger');
                    return;
                }

                this.active = this.reduction_types[index].active == 1?true:false;
                this.sort_order = this.reduction_types[index].sort_order;
                this.name = this.reduction_types[index].name;
                this.id = this.reduction_types[index].id;
                this.toggleForm = false;
            },

            update() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .put(`/api/reduction-types/${this.id}`, {
                        name: this.name,
                        sort_order: this.sort_order,
                        active: this.active
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);
                            this.getReductionTypes();
                            this.cancel();
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }
                        this.isLoading = false;
                    })
            },

            cancel() {
                this.active = false;
                this.sort_order = null;
                this.name = '';
                this.id = null;
                this.toggleForm = true;
            },

            remove(type) {
                if(!this.permissions.deleteSettingsReductiontypes){
                    this.showAlert(this.$t('form.validation.cantDeleteReductionTypePermission'),'danger');
                    return;
                }
                if(type.active == 1){
                    this.showAlert(this.$t('form.validation.cantDeleteReductionTypeInUse'),'danger');
                    return;
                }
                if (confirm(this.$t('form.validation.delete'))) {

                    this.clear();
                    this.isLoading = true;
                    var index = type.id;
                    axios
                        .delete(`/api/reduction-types/${index}`)
                        .then(response => {
                            if (response.data.success) {
                                this.showAlert(response.data.message);
                                this.getReductionTypes();
                                
                            }

                            this.isLoading = false;
                        })
                        .catch(error => {
                            console.log(error)
                            if (error.response.status === 422) {
                                this.showAlert(error.response.data.message, 'danger');
                            }

                            this.isLoading = false;
                        })
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>
